// extracted by mini-css-extract-plugin
export default {"title":"styles_title__GevOU","deliDate":"styles_deliDate__3RteU","status":"styles_status__ThC9M"};